import React from 'react'
import { Button } from 'antd'
import { Tooltip } from 'antd'
import { FileOutlined } from '@ant-design/icons'
import Delete from '~/components/deleteConfirm'

export const getColumns = (
	handleToGo,
	handleDelete,
	handleModalListDocuments
) => [
	{
		title: 'Descrição',
		dataIndex: 'description',
		key: 'description',
		render: (text, row) => (
			<Button type="link" onClick={() => handleToGo(row)}>
				{text}
			</Button>
		),
	},
	{
		title: 'Tags',
		dataIndex: 'tags',
		key: 'tags',
	},
	{
		title: '',
		dataIndex: 'action',
		key: 'action',
		render: (text, row) => (
			<div style={{ display: 'flex', alignItems: 'right' }}>
				<Delete
					title="Deseja excluir esse texto?"
					handle={() => handleDelete(row)}
				/>
				<div>
					<Tooltip
						placement="top"
						title={'Lista todos os documentos deste item.'}>
						<FileOutlined
							style={{
								fontSize: '20px',
								color: 'var(--ant-primary-color)',
								verticalAlign: 'middle',
								marginLeft: '8px',
							}}
							onClick={() => handleModalListDocuments(row)}
						/>
					</Tooltip>
				</div>
			</div>
		),
	},
]
